/* eslint-disable react/no-direct-mutation-state */
import React from 'react';
import { connect } from "react-redux";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import { injectIntl } from "react-intl";
import Form, { Item as FormItem, SimpleItem, RequiredRule, GroupItem, RangeRule } from 'devextreme-react/form';
import { withSnackbar } from 'notistack';
import * as companiesCrud from '../../../../crud/companies.crud';
import * as contractsCrud from '../../../../crud/contracts.crud';


export const RESPONSES = {
    SAVE: 'SAVE',
    CANCEL: 'CANCEL',
};

class SystemSettingsFilterModal extends React.Component {
    constructor(props) {
        super(props);
        this.validatorRef = React.createRef();
        this.validatorName = 'SystemSettingsFilterModalValidator';
        this.formRef = React.createRef();
        this.popupRef = React.createRef();
        this.fileUploaderRef = React.createRef();
        this.uploadButtonRef = React.createRef();
        this.formData = {}
        this.defaultFields = null;
        this.state = {
        }
    }
    componentDidMount() {
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.visible !== true && this.props.visible === true) {
            if (this.formRef.current) {
                this.formRef.current.instance().clear();
            }
            if (this.popupRef.current) {
                this.popupRef.current.instance().option("toolbarItems[2].disabled", true);
            }
        }
        else if (prevProps.visible === true && this.props.visible === false) {
            //popup closed
        }

    }
    componentWillUnmount() {
        if (this.props.closeSnackbar) {
            this.props.closeSnackbar();
        }
    }
    onClose = (e) => {
        if (this.props.visible) {
            // e.cancel = true;
            if (this.props.closeSnackbar) {
                this.props.closeSnackbar();
            }
            this.props.onDialogResult();
        }
    }

    formFieldDataChanged = async (e) => {
        this.formData = e.component.option("formData");
        if (!this.formData.companyid && !this.formData.showsystemdefaults) {
            //IF ANY FIELD CLEARED MAKE SURE UPLOAD BUTTON IS DISABLED
            this.popupRef.current.instance().option("toolbarItems[2].disabled", true);
        }
        else {
            this.popupRef.current.instance().option("toolbarItems[2].disabled", false);
        }

        if (this.props.closeSnackbar) {
            this.props.closeSnackbar();
        }
        if (e.dataField === 'showsystemdefaults') {
            const formInstance = this.formRef.current.instance();
            if (e.value === true) {
                formInstance.option("items[1].editorOptions.disabled", true);
                formInstance.option("items[2].editorOptions.disabled", true);

                e.component.updateData("companyid", null);
                e.component.updateData("contractid", null);
            }
            else {
                formInstance.option("items[1].editorOptions.disabled", false);
                formInstance.option("items[2].editorOptions.disabled", false);
            }
        }
        else if (e.dataField === 'companyid') {
            let contractDataSource = null;
            if (e.value) {
                contractDataSource = this.getContractOptions(Number(e.value));
            }
            e.component.itemOption("contractid", "editorOptions", { dataSource: contractDataSource });
            e.component.updateData("contractid", null);
        }
    }

    getCompaniesListDataSource = () => {
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise((resolve) => {
                    companiesCrud.getCutDownCompaniesList()
                        .then(resp => {
                            resolve(resp.data);
                        })
                });
                return promise;
            }
        }
        return datasource;
    }
    getContractOptions = (companyid) => {
        const datasource = {
            loadMode: 'raw',
            cacheRawData: true,
            load: () => {
                var promise = new Promise((resolve, reject) => {
                    contractsCrud.toSelectList(companyid)
                        .then(response => {
                            let retVal = [];
                            if (response.data) {
                                retVal = response.data;
                            }
                            resolve(retVal);
                        })
                        .catch((err) => {
                            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
                            reject(err);
                        })
                });
                return promise;
            }
        }
        return datasource;
    }
    applyFilter = () => {
        if (this.formRef.current) {
            const formInstance = this.formRef.current.instance();

            if (formInstance.validate().isValid) {
                this.props.onDialogResult(this.formData);
            }
        }
    }
    render() {
        return (
            <>
                <Popup
                    id='SystemSettingsFilterModalPopup'
                    ref={this.popupRef}
                    visible={this.props.visible}
                    onHiding={this.onClose}
                    dragEnabled={true}
                    hideOnOutsideClick={false}
                    width={600}
                    height='auto'>
                    <Form
                        ref={this.formRef}
                        onFieldDataChanged={this.formFieldDataChanged}
                        labelMode='outside'
                        labelLocation='top'
                    >
                        <FormItem
                            dataField="showsystemdefaults"
                            editorType="dxCheckBox"
                            label={{ visible: false }}
                            editorOptions={{
                                enableThreeStateBehavior: false,
                                text: "Show System Defaults",

                            }}
                        />
                        <FormItem
                            label={{ text: this.props.intl.formatMessage({ id: 'PROJECT.FIELD.COMPANY' }) }}
                            dataField="companyid"
                            editorType="dxSelectBox"

                            editorOptions={{
                                dataSource: this.getCompaniesListDataSource(),
                                showClearButton: true,
                                valueExpr: 'companyid',
                                displayExpr: 'name',
                                searchEnabled: true,
                            }}
                            isRequired={true}
                        />
                        <FormItem
                            label={{ text: "Contract" }}
                            dataField="contractid"
                            editorType="dxSelectBox"
                            editorOptions={{
                                showClearButton: true,
                                valueExpr: 'contractid',
                                displayExpr: 'name',
                                searchEnabled: true,
                                placeholder : "Leave blank for all contracts",
                            }}
                        />
                    </Form>
                    <ToolbarItem location="before"
                        locateInMenu="never"
                        template={`<div style=\"font-size: 20px;\">View Applied Settings</div>`}
                    />
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{ text: this.props.intl.formatMessage({ id: 'GENERAL.FORMS.BUTTON_CANCEL' }), onClick: this.onClose }}>
                    </ToolbarItem>
                    <ToolbarItem
                        widget="dxButton"
                        toolbar="bottom"
                        location="after"
                        options={{
                            text: "View Applied",
                            icon: 'save',
                            onClick: this.applyFilter,
                        }}>
                    </ToolbarItem>
                </Popup >
            </>

        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    contractTemplate: store.contract.template,
});

export default connect(mapStateToProps)(withSnackbar(injectIntl(SystemSettingsFilterModal)));